import { IGResponse } from "@common/models";
import { IEvent } from "@common/models/CMS";
import Title from "@components/general/Title";
import UpcomingMonth from "@components/general/UpcomingMonth";
import UpcomingEvent from "@components/UpcomingEvent";
import { Page } from "@pages/page";
import { EVENTS, useApolloQuery } from "@service/graphql";
import Translate from "@service/Translate";
import { FC } from "react";

const Event: FC = () => {
    const { tr } = Translate;
    const { data, loading } = useApolloQuery<IGResponse<IEvent[]>>(EVENTS);
    // const dataSource = data?.event?.slice().sort((a, b) => (new Date(a.startTime || 0).getTime()) - (new Date(b.startTime || 0).getTime())) || [];

    return (
        <Page
            className="event"
            bodyContainer={false}
        >
            <div className="container mt-10">
                <Title text={tr("upcoming_months")} border="center" />
                {loading ? 'loading' : <UpcomingMonth dataSource={data?.event || []} />}
                {/* <WidgetHeader
                    dataSource={{
                        title: tr("events"),
                        description: tr("events_sub_title"),
                        alignment: 'Center'
                    }}
                /> */}
                <Title text={tr("events")} border="center" />
                <p className="description text-center">{tr("events_sub_title")}</p>
            </div>
            {
                loading ? 'loading' :
                    <UpcomingEvent dataSource={data?.event || []} />
            }
        </Page>
    )
}

export default Event;